export default {
  desktopBreakpoint: 1280, // ie: When should videos use the desktop layout?

  getDeviceType () {
    return window.innerWidth >= this.desktopBreakpoint ? 'desktop' : 'mobile'
  },
  isDesktop () {
    return this.getDeviceType() === 'desktop'
  },
  isMobile () {
    return this.getDeviceType() === 'mobile'
  }
}
